import React from "react";
import { Flex, Button, Text, Center } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const PaginationComponent = ({
  currentPage,
  totalPages,
  handleNextTaskCard,
  handlePreviousTaskCard,
  disablePrevious,
  disableNext,
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="end"
      bg="lavender"
      p={4}
      borderRadius="md"
    >
      <Button
        variant="ghost"
        mr={4}
        w="40px"
        h="36px"
        opacity={disablePrevious ? 0.5 : 1}
        pointerEvents={disablePrevious ? "none" : "auto"}
        bg="white"
        aria-label="Previous page"
        onClick={() => {
          handlePreviousTaskCard();
        }}
      >
        <Center w="100%" h="100%">
          <ChevronLeftIcon />
        </Center>
      </Button>
      <Text fontSize="md" fontWeight="medium">
        {currentPage} of {totalPages}
      </Text>
      <Button
        variant="ghost"
        ml={4}
        w="40px"
        h="36px"
        opacity={disableNext ? 0.5 : 1}
        pointerEvents={disableNext ? "none" : "auto"}
        bg="white"
        aria-label="Next page"
        onClick={() => {
          handleNextTaskCard();
        }}
      >
        <Center w="100%" h="100%">
          <ChevronRightIcon />
        </Center>
      </Button>
    </Flex>
  );
};

export default PaginationComponent;
